import styled from "@emotion/styled";
import React from "react";
import PropTypes from "prop-types";
import Checkbox from '@material-ui/core/Checkbox';
import TranslateTransition from "../animations/TranslateTransition";

const CustomerRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 42px repeat(auto-fill, 276px);
    grid-column-start: 1;
    grid-column-end: 5;
    align-items: center;
`;

export const TableCell = styled.span``;

const CustomerRowHeading = styled.h3`
    font-size: var(--font-m);
    color: var(--font-secondary);
    font-weight: 300;
    text-align: center;
    width: fit-content;
    margin: 15px;
`;

export default function CustomerTableRowComponent(props) {

    const {rowHeading, columnHeaders, rowData, selectedCustomers, onCustomerCheckboxSelected} = props;

    return (
        <>
            <CustomerRowHeading>{rowHeading}</CustomerRowHeading>
            {
                rowData.map((item, index) => {
                    return (
                        <TranslateTransition key={index}>
                            <CustomerRow key={index}>
                                {/*TODO work on selection logic*/}
                                <Checkbox
                                    value={item.name}
                                    checked={selectedCustomers.includes(item.id)}
                                    onChange={e => onCustomerCheckboxSelected(e, item)}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}
                                />
                                {
                                    columnHeaders.map((columnHeadingData, index) => {
                                        // return item.tableFields[columnHeadingData.key]
                                        return React.cloneElement(
                                            item.tableFields[columnHeadingData.key],
                                            {key: index}
                                        );
                                    })
                                }
                            </CustomerRow>
                        </TranslateTransition>
                    )
                })
            }
        </>
    )
}

CustomerTableRowComponent.propTypes = {
    rowHeading: PropTypes.string,
    columnHeaders: PropTypes.array,
    rowData: PropTypes.array,
    isSelected: PropTypes.bool,
    onCustomerCheckboxSelected: PropTypes.func
};
